<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <dr-list-view-editor 
      :class="evaluateClasses(classes)"
    />
  </dr-wrapper>
  <dr-list-view-component v-else
    :class="evaluateClasses(classes)"
    :isAppInIFrame="isAppInIFrame"
    v-bind="$props"
  />
</template>
<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'

export default {
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  components: {
    'dr-list-view-editor': () => import('./dr-list-view-editor'),
    'dr-list-view-component': () => import('./dr-list-view-component')
  },
  computed: {
    // false - страница загружена во фрейме
    // true - страница загружена в основном окне
    isAppInIFrame() {
      let isFramed
      try {
        isFramed = window != window.top || document != top.document || self.location != top.location
      } catch (e) {
        isFramed = true
      }
      return isFramed
    }
  }
}
</script>

<style>
  .list-view-main-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .list-view-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    transition: 0.2s;
    cursor: pointer;
    border-top: none;
    border-left: none;
  }

  .list-view-item:hover {
    color: var(--accentColor);
  }

  .list-view-item:hover .list-view-icon-container {
    box-shadow: 0 2px 2px rgb(0 0 0 / 10%), 0 6px 10px rgb(0 0 0 / 10%);
  }

  .list-view-container {
    display: flex;
    flex: 100;
    min-height: 0;
    flex-wrap: wrap;
    align-content: flex-start;
    position: relative;
    height: 100%;
    width: 100%;
  }

  .list-view-item-normal{
    position: absolute;
    height: 90px;
    width: 115px;
    padding: 2px;
    border-left: none;
    border-top: none;
    max-width: 100%;
    box-sizing: unset;
  }

  .list-view-icon-container {
    display: flex;
    padding: 7px;
    border-radius: 50%;
    box-sizing: border-box;
    justify-content: center;
  }

  .list-view-caption {
    flex: 1;
    display: block;
    max-width: 100%;
    overflow: hidden;
    font-size: 13px;
    text-overflow: ellipsis;
    font-family: Roboto, sans;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
</style>